export default __webpack_public_path__ + "static/media/user_icon_active.0698ae9d.svg";